import { getHighlightedJs } from "./utils/highlightJs.util";
import { getHighlightedJs as getHighlightedJsPrism } from "./utils/highlightPrism.util";
import Code from './Code';

export default function SyntaxHighlighting() {
  const code = `function helloWorld() {
    console.log('this is a print');
}
  `;
  return (
    <div className="content-container">
      <h2>Syntax highlighting</h2>
      <h3>Raw</h3>
      <Code>{code}</Code>
      <h3>highlight.js</h3>
      <Code>{getHighlightedJs(code)}</Code>
      <h3>Prismjs</h3>
      <Code>{getHighlightedJsPrism(code)}</Code>
    </div>
  );
}